export default {
    watchQuery: true,
    computed: {
        searchResult() {
            return this.$store.state.searchResult;
        },
        teaserBackground() {
            //feel free to add items, making a carousel of teasers
            return this.$getSafe(this.searchResult, 'pageData.teaserImageUrl');
        },
        filterOptions() {
            return (
                (typeof this.$route.query.filterOptions === 'string'
                    ? [this.$route.query.filterOptions]
                    : this.$route.query.filterOptions) || []
            );
        },
        initialState() {
            return !this.$route.query.q && !this.filterOptions.length && !this.$route.query.from;
        }
    }
};
